<script lang="ts" setup>
/**
 * A simple alert dialog that displays a title, message, and a single action button.
 * Renders as an action sheet on mobile and a dialog on desktop.
 */

withDefaults(defineProps<{
  name: string
  danger?: boolean
  buttonLabel?: string
}>(), { danger: false,buttonLabel: 'Close', })

let open = (defineModel<boolean>('open', { default: false }))

const emit = defineEmits<{ close: [] }>()

function close () {
  open.value = false
  emit('close')
}
</script>

<template>
  <GSheetDialog
    v-model:open="open"
    :name="name"
    width="mediumwide"
    class="g-alert-modal"
    hideCloseButton
    noFlashTarget
    @close="close"
  >
    <template v-if="$slots.header" #header>
      <span :class="[danger ? 'text-red-base' : 'text-navy']">
        <slot name="header"/>
      </span>
    </template>

    <div class="flex-auto flex flex-col text-center">
      <slot/>
    </div>

    <template #footer>
      <GButton
        tertiary
        size="large"
        :name="`close-alert-modal-button-${name}`"
        :label="buttonLabel"
        @click="close"
      />
    </template>
  </GSheetDialog>
</template>
